import React from 'react';

import { Avatar, Box } from '@mui/material';

import { MissingLog } from '../../images/index';

const MissingLogIcon = () => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Avatar alt="MissinLog Icon" src={MissingLog} sx={{ width: 24, height: 24 }} />
    </Box>
  );
};

export default MissingLogIcon;
